import { AxiosRequestConfig } from "axios";

import { axiosInstance } from "../api/axiosConfig";
import { store } from "../redux/store";
import { setUser, updateCompleted } from "../redux/user.slice";

export const saveUserLanguage = (
  language: "en" | "fr" | string,
  options: AxiosRequestConfig,
) => {
  return axiosInstance.post(
    "/user/",
    {
      language: language,
    },
    options,
  );
};

export const getUserData = async (options: AxiosRequestConfig) => {
  const { data } = await axiosInstance.get("/user/", options);
  store.dispatch(setUser(data.data));

  return data.data;
};


export const check2fa = (options: AxiosRequestConfig) => {
  return axiosInstance.get('/user/is-2fa-enabled/', options)
}

export const disable2fa = (options: AxiosRequestConfig) => {
  return axiosInstance
    .put(
      "/user/disable-2fa/",
      {},
      options
    );
}

export const verify2fa = (options: AxiosRequestConfig) => {
  return axiosInstance
    .put(
      "/user/verify-2fa/",
      {},
      options
    )
}

export const setup2fa = (data?: any, options?: AxiosRequestConfig) => {
  return axiosInstance.post("/user/enable-2fa/", data, options);
}

export const logoutBE = (options?: AxiosRequestConfig) => {
  return axiosInstance.get("/user/logout/", options);
}

export const completeTour = (data: "dashboard" | "smart_allocation" | "trade" | "sa_rules" | "templates", options?: AxiosRequestConfig) => {
  return axiosInstance.post("/user/onboarding", {
  }, {
    ...options, params: {
      onboarding_name: data
    }
  }).then(() => {
    if (store.getState().user.completed_onboarding != null)
      store.dispatch(updateCompleted([...store.getState().user.completed_onboarding as string[], data]))
    else
      store.dispatch(updateCompleted([data]))
  })
}